<div class="fresh-ui">
  <div class="video-editing-page d-md-flex d-none">
    <nav class="navbar navbar-expand-lg navbar-personalize fixed-top">
      <div
        class="collapse navbar-collapse d-flex justify-content-between"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav pr-0 w-in-mobile">
          <li class="nav-item active d-flex justify-content-between">
            <button
              class="btn-personalization px-2 btn-back"
              (click)="goBack()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="#5f6368"
              >
                <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
              </svg>
            </button>
            <div
              class="mobile-reorder px-0 mobile-reorder-static w-auto"
              #mobileReorder
            >
              <div
                class="d-flex justify-content-start w-100 align-items-center"
                style="gap: 15px"
              >
                <div class="px-0">
                  <div
                    class="d-flex flex-column align-items-center button cursor-pointer  btn btn-light-gray"
                    (click)="toggleSlideIn('delete')"
                  >
                    <div class="d-flex align-items-center" style="gap: 5px">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        viewBox="0 -960 960 960"
                        width="20px"
                        fill="#5f6368"
                      >
                        <path
                          d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                        />
                      </svg>
                      <p class="text-dark mb-0">Delete</p>
                    </div>
                  </div>
                </div>
                <div class="px-0">
                  <div
                    class="d-flex flex-column align-items-center button cursor-pointer btn btn-light-gray"
                    (click)="toggleSlideIn('swap')"
                  >
                    <div class="d-flex align-items-center" style="gap: 8px">
                      <svg
                        height="20px"
                        width="20px"
                        version="1.1"
                        id="_x32_"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 512 512"
                        xml:space="preserve"
                        fill="#5f6368"
                      >
                       
                        <g>
                          <polygon  
                            class="st0"
                            points="256,381.424 104.628,328.845 0,365.186 256,454.114 512,365.186 407.373,328.845 	"
                          />
                          <polygon
                            class="st0"
                            points="256,272.235 104.628,219.655 0,255.996 256,344.924 512,255.996 407.373,219.655 	"
                          />
                          <polygon
                            class="st0"
                            points="512,146.806 256,57.886 0,146.806 256,235.734 	"
                          />
                        </g>
                      </svg>
                      <p class="text-dark mb-0">Re-Order</p>
                    </div>
                  </div>
                </div>
                <div class="px-0">
                  <div
                    class="d-flex flex-column align-items-center button cursor-pointer btn btn-light-gray"
                    (click)="goToSlide(TemplateMetaData?.SlideData?.length + 1)"
                  >
                    <div class="d-flex align-items-center" style="gap: 8px">
                      <svg
                        fill="#5f6368"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="20px"
                        height="20px"
                        viewBox="0 0 31.216 31.216"
                        xml:space="preserve"
                      >
                        <g>
                          <path
                            d="M30.854,0L11.057,2.837v18.034c-1.089-0.596-2.405-0.94-3.838-0.94c-3.845,0-6.856,2.479-6.856,5.642
		c0,3.164,3.012,5.644,6.856,5.644c3.844,0,6.856-2.479,6.856-5.644c0-0.104-0.019-13.353-0.019-13.353l13.797-2.213v8.487
		c-1.1-0.613-2.434-0.971-3.891-0.971c-3.844,0-6.855,2.479-6.855,5.642c0,3.165,3.012,5.644,6.855,5.644
		c3.686,0,6.598-2.279,6.832-5.255C30.829,23.428,30.854,0,30.854,0z M7.218,28.215c-2.13,0-3.856-1.184-3.856-2.643
		s1.727-2.643,3.856-2.643c2.066,0,3.74,1.116,3.838,2.516v0.127c0,0.025,0.006,0.049,0.008,0.074
		C11.004,27.07,9.311,28.215,7.218,28.215z M14.057,9.18V5.438L27.854,3.46v3.507L14.057,9.18z M23.964,25.809
		c-2.129,0-3.856-1.184-3.856-2.645c0-1.459,1.728-2.641,3.856-2.641s3.854,1.182,3.854,2.641
		C27.818,24.626,26.093,25.809,23.964,25.809z"
                          />
                        </g>
                      </svg>
                      <p class="text-dark mb-0">Music</p>
                    </div>
                  </div>
                </div>
                <div class="px-0 d-none">
                  <div class="d-flex align-items-center button">
                    <div class="d-flex cursor-pointer" (click)="openInsText()">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.5208 6.90417 10.7125 6.7125C10.9042 6.52083 11 6.28333 11 6C11 5.71667 10.9042 5.47917 10.7125 5.2875C10.5208 5.09583 10.2833 5 10 5C9.71667 5 9.47917 5.09583 9.2875 5.2875C9.09583 5.47917 9 5.71667 9 6C9 6.28333 9.09583 6.52083 9.2875 6.7125C9.47917 6.90417 9.71667 7 10 7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                          fill="#63696C"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!-- <ul class="navbar-nav d-none d-md-flex">
          <li class="nav-item">
            <button class="btn-navbar-personalization">Re-Order Slide</button>
          </li>
        </ul> -->
        <form class="form-inline d-none d-md-flex">
          <!-- <p class="video-title-name pr-4">Morder Flower Wedding Invitation</p> -->
          <button
            class="btn-navbar-personalization btn-upload-outline"
            type="button"
            *ngIf="invitationType == 1"
            (click)="goToSlide(TemplateMetaData?.SlideData?.length + 1)"
          >
            <svg
              width="22px"
              height="22px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 16V3M12 3L16 7.375M12 3L8 7.375"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Upload Music</span>
          </button>
          <button
            class="btn-navbar-personalization btn-next ml-3"
            type="button"
            *ngIf="invitationType == 1"
            (click)="GenerateVideo($event)"
            [ngClass]="{
              active: TemplateMetaData?.SlideData?.length == activeSlide
            }"
          >
            <svg
              width="22"
              height="15"
              viewBox="0 0 22 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 12C12.25 12 13.3125 11.5625 14.1875 10.6875C15.0625 9.8125 15.5 8.75 15.5 7.5C15.5 6.25 15.0625 5.1875 14.1875 4.3125C13.3125 3.4375 12.25 3 11 3C9.75 3 8.6875 3.4375 7.8125 4.3125C6.9375 5.1875 6.5 6.25 6.5 7.5C6.5 8.75 6.9375 9.8125 7.8125 10.6875C8.6875 11.5625 9.75 12 11 12ZM11 10.2C10.25 10.2 9.6125 9.9375 9.0875 9.4125C8.5625 8.8875 8.3 8.25 8.3 7.5C8.3 6.75 8.5625 6.1125 9.0875 5.5875C9.6125 5.0625 10.25 4.8 11 4.8C11.75 4.8 12.3875 5.0625 12.9125 5.5875C13.4375 6.1125 13.7 6.75 13.7 7.5C13.7 8.25 13.4375 8.8875 12.9125 9.4125C12.3875 9.9375 11.75 10.2 11 10.2ZM11 15C8.56667 15 6.35 14.3208 4.35 12.9625C2.35 11.6042 0.9 9.78333 0 7.5C0.9 5.21667 2.35 3.39583 4.35 2.0375C6.35 0.679167 8.56667 0 11 0C13.4333 0 15.65 0.679167 17.65 2.0375C19.65 3.39583 21.1 5.21667 22 7.5C21.1 9.78333 19.65 11.6042 17.65 12.9625C15.65 14.3208 13.4333 15 11 15ZM11 13C12.8833 13 14.6125 12.5042 16.1875 11.5125C17.7625 10.5208 18.9667 9.18333 19.8 7.5C18.9667 5.81667 17.7625 4.47917 16.1875 3.4875C14.6125 2.49583 12.8833 2 11 2C9.11667 2 7.3875 2.49583 5.8125 3.4875C4.2375 4.47917 3.03333 5.81667 2.2 7.5C3.03333 9.18333 4.2375 10.5208 5.8125 11.5125C7.3875 12.5042 9.11667 13 11 13Z"
                fill="#fff"
              />
            </svg>
            <span>Preview Video</span>
          </button>
          <button
            class="btn-navbar-personalization btn-next"
            type="button"
            *ngIf="invitationType == 2"
            (click)="GenerateVideo($event)"
            [ngClass]="{
              active: TemplateMetaData?.SlideData?.length == activeSlide
            }"
          >
            <svg
              width="22"
              height="15"
              viewBox="0 0 22 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 12C12.25 12 13.3125 11.5625 14.1875 10.6875C15.0625 9.8125 15.5 8.75 15.5 7.5C15.5 6.25 15.0625 5.1875 14.1875 4.3125C13.3125 3.4375 12.25 3 11 3C9.75 3 8.6875 3.4375 7.8125 4.3125C6.9375 5.1875 6.5 6.25 6.5 7.5C6.5 8.75 6.9375 9.8125 7.8125 10.6875C8.6875 11.5625 9.75 12 11 12ZM11 10.2C10.25 10.2 9.6125 9.9375 9.0875 9.4125C8.5625 8.8875 8.3 8.25 8.3 7.5C8.3 6.75 8.5625 6.1125 9.0875 5.5875C9.6125 5.0625 10.25 4.8 11 4.8C11.75 4.8 12.3875 5.0625 12.9125 5.5875C13.4375 6.1125 13.7 6.75 13.7 7.5C13.7 8.25 13.4375 8.8875 12.9125 9.4125C12.3875 9.9375 11.75 10.2 11 10.2ZM11 15C8.56667 15 6.35 14.3208 4.35 12.9625C2.35 11.6042 0.9 9.78333 0 7.5C0.9 5.21667 2.35 3.39583 4.35 2.0375C6.35 0.679167 8.56667 0 11 0C13.4333 0 15.65 0.679167 17.65 2.0375C19.65 3.39583 21.1 5.21667 22 7.5C21.1 9.78333 19.65 11.6042 17.65 12.9625C15.65 14.3208 13.4333 15 11 15ZM11 13C12.8833 13 14.6125 12.5042 16.1875 11.5125C17.7625 10.5208 18.9667 9.18333 19.8 7.5C18.9667 5.81667 17.7625 4.47917 16.1875 3.4875C14.6125 2.49583 12.8833 2 11 2C9.11667 2 7.3875 2.49583 5.8125 3.4875C4.2375 4.47917 3.03333 5.81667 2.2 7.5C3.03333 9.18333 4.2375 10.5208 5.8125 11.5125C7.3875 12.5042 9.11667 13 11 13Z"
                fill="#fff"
              />
            </svg>
            <span>Preview Card</span>
          </button>
          <button
            class="btn-navbar-personalization btn-next ml-3"
            [disabled]="isSaveDisable || isPayDisable"
            (click)="payAndDownload()"
          >
            Download
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 6.00007C13.9951 5.47397 13.7832 4.97097 13.41 4.60007L9.12 0.30007C8.93264 0.113819 8.67919 0.00927734 8.415 0.00927734C8.15082 0.00927734 7.89736 0.113819 7.71 0.30007C7.61627 0.393033 7.54188 0.503634 7.49111 0.625494C7.44034 0.747353 7.4142 0.878058 7.4142 1.01007C7.4142 1.14208 7.44034 1.27279 7.49111 1.39465C7.54188 1.51651 7.61627 1.62711 7.71 1.72007L11 5.00007H1C0.734784 5.00007 0.48043 5.10543 0.292893 5.29296C0.105357 5.4805 0 5.73485 0 6.00007C0 6.26529 0.105357 6.51964 0.292893 6.70718C0.48043 6.89471 0.734784 7.00007 1 7.00007H11L7.71 10.2901C7.5217 10.477 7.41538 10.7312 7.41444 10.9965C7.41351 11.2619 7.51802 11.5168 7.705 11.7051C7.89198 11.8934 8.1461 11.9997 8.41147 12.0006C8.67683 12.0016 8.9317 11.897 9.12 11.7101L13.41 7.41007C13.7856 7.03672 13.9978 6.52965 14 6.00007Z"
                fill="white"
              />
            </svg>
          </button>
        </form>
      </div>
    </nav>
  </div>
  <div class="p-navbar d-flex d-md-none">
    <nav class="navbar navbar-expand-lg navbar-personalize fixed-top">
      <div
        class="collapse navbar-collapse d-flex justify-content-between"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav pr-0 w-in-mobile">
          <li class="nav-item active d-flex justify-content-between">
            <button
              class="btn-personalization px-2 btn-back"
              (click)="goBack()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="#5f6368"
              >
                <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
              </svg>
            </button>
            <div
              class="mobile-reorder px-0 mobile-reorder-static w-auto"
              #mobileReorder
            >
              <div
                class="d-flex justify-content-start w-100 align-items-center"
                style="gap: 15px"
              >
                <div class="px-0">
                  <div
                    class="d-flex flex-column align-items-center button cursor-pointer  btn btn-light-gray"
                    (click)="toggleSlideIn('delete')"
                  >
                    <div class="d-flex align-items-center" style="gap: 5px">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        viewBox="0 -960 960 960"
                        width="20px"
                        fill="#5f6368"
                      >
                        <path
                          d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                        />
                      </svg>
                      <p class="text-dark mb-0">Delete</p>
                    </div>
                  </div>
                </div>
                <div class="px-0">
                  <div
                    class="d-flex flex-column align-items-center button cursor-pointer btn btn-light-gray"
                    (click)="toggleSlideIn('swap')"
                  >
                    <div class="d-flex align-items-center" style="gap: 8px">
                      <svg
                        height="20px"
                        width="20px"
                        version="1.1"
                        id="_x32_"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 512 512"
                        xml:space="preserve"
                        fill="#5f6368"
                      >
                       
                        <g>
                          <polygon  
                            class="st0"
                            points="256,381.424 104.628,328.845 0,365.186 256,454.114 512,365.186 407.373,328.845 	"
                          />
                          <polygon
                            class="st0"
                            points="256,272.235 104.628,219.655 0,255.996 256,344.924 512,255.996 407.373,219.655 	"
                          />
                          <polygon
                            class="st0"
                            points="512,146.806 256,57.886 0,146.806 256,235.734 	"
                          />
                        </g>
                      </svg>
                      <p class="text-dark mb-0">Re-Order</p>
                    </div>
                  </div>
                </div>
                <div class="px-0">
                  <div
                    class="d-flex flex-column align-items-center button cursor-pointer btn btn-light-gray"
                    (click)="goToSlide(TemplateMetaData?.SlideData?.length + 1)"
                  >
                    <div class="d-flex align-items-center" style="gap: 8px">
                      <svg
                        fill="#5f6368"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="20px"
                        height="20px"
                        viewBox="0 0 31.216 31.216"
                        xml:space="preserve"
                      >
                        <g>
                          <path
                            d="M30.854,0L11.057,2.837v18.034c-1.089-0.596-2.405-0.94-3.838-0.94c-3.845,0-6.856,2.479-6.856,5.642
		c0,3.164,3.012,5.644,6.856,5.644c3.844,0,6.856-2.479,6.856-5.644c0-0.104-0.019-13.353-0.019-13.353l13.797-2.213v8.487
		c-1.1-0.613-2.434-0.971-3.891-0.971c-3.844,0-6.855,2.479-6.855,5.642c0,3.165,3.012,5.644,6.855,5.644
		c3.686,0,6.598-2.279,6.832-5.255C30.829,23.428,30.854,0,30.854,0z M7.218,28.215c-2.13,0-3.856-1.184-3.856-2.643
		s1.727-2.643,3.856-2.643c2.066,0,3.74,1.116,3.838,2.516v0.127c0,0.025,0.006,0.049,0.008,0.074
		C11.004,27.07,9.311,28.215,7.218,28.215z M14.057,9.18V5.438L27.854,3.46v3.507L14.057,9.18z M23.964,25.809
		c-2.129,0-3.856-1.184-3.856-2.645c0-1.459,1.728-2.641,3.856-2.641s3.854,1.182,3.854,2.641
		C27.818,24.626,26.093,25.809,23.964,25.809z"
                          />
                        </g>
                      </svg>
                      <p class="text-dark mb-0">Music</p>
                    </div>
                  </div>
                </div>
                <div class="px-0 d-none">
                  <div class="d-flex align-items-center button">
                    <div class="d-flex cursor-pointer" (click)="openInsText()">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.5208 6.90417 10.7125 6.7125C10.9042 6.52083 11 6.28333 11 6C11 5.71667 10.9042 5.47917 10.7125 5.2875C10.5208 5.09583 10.2833 5 10 5C9.71667 5 9.47917 5.09583 9.2875 5.2875C9.09583 5.47917 9 5.71667 9 6C9 6.28333 9.09583 6.52083 9.2875 6.7125C9.47917 6.90417 9.71667 7 10 7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                          fill="#63696C"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!-- <ul class="navbar-nav d-none d-md-flex">
          <li class="nav-item">
            <button class="btn-navbar-personalization">Re-Order Slide</button>
          </li>
        </ul> -->
        <form class="form-inline d-none d-md-flex">
          <!-- <p class="video-title-name pr-4">Morder Flower Wedding Invitation</p> -->
          <button
            class="btn-navbar-personalization btn-upload-outline"
            type="button"
            *ngIf="invitationType == 1"
            (click)="goToSlide(TemplateMetaData?.SlideData?.length + 1)"
          >
            <svg
              width="22px"
              height="22px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 16V3M12 3L16 7.375M12 3L8 7.375"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Upload Music</span>
          </button>
          <button
            class="btn-navbar-personalization btn-next ml-3"
            type="button"
            *ngIf="invitationType == 1"
            (click)="GenerateVideo($event)"
            [ngClass]="{
              active: TemplateMetaData?.SlideData?.length == activeSlide
            }"
          >
            <svg
              width="22"
              height="15"
              viewBox="0 0 22 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 12C12.25 12 13.3125 11.5625 14.1875 10.6875C15.0625 9.8125 15.5 8.75 15.5 7.5C15.5 6.25 15.0625 5.1875 14.1875 4.3125C13.3125 3.4375 12.25 3 11 3C9.75 3 8.6875 3.4375 7.8125 4.3125C6.9375 5.1875 6.5 6.25 6.5 7.5C6.5 8.75 6.9375 9.8125 7.8125 10.6875C8.6875 11.5625 9.75 12 11 12ZM11 10.2C10.25 10.2 9.6125 9.9375 9.0875 9.4125C8.5625 8.8875 8.3 8.25 8.3 7.5C8.3 6.75 8.5625 6.1125 9.0875 5.5875C9.6125 5.0625 10.25 4.8 11 4.8C11.75 4.8 12.3875 5.0625 12.9125 5.5875C13.4375 6.1125 13.7 6.75 13.7 7.5C13.7 8.25 13.4375 8.8875 12.9125 9.4125C12.3875 9.9375 11.75 10.2 11 10.2ZM11 15C8.56667 15 6.35 14.3208 4.35 12.9625C2.35 11.6042 0.9 9.78333 0 7.5C0.9 5.21667 2.35 3.39583 4.35 2.0375C6.35 0.679167 8.56667 0 11 0C13.4333 0 15.65 0.679167 17.65 2.0375C19.65 3.39583 21.1 5.21667 22 7.5C21.1 9.78333 19.65 11.6042 17.65 12.9625C15.65 14.3208 13.4333 15 11 15ZM11 13C12.8833 13 14.6125 12.5042 16.1875 11.5125C17.7625 10.5208 18.9667 9.18333 19.8 7.5C18.9667 5.81667 17.7625 4.47917 16.1875 3.4875C14.6125 2.49583 12.8833 2 11 2C9.11667 2 7.3875 2.49583 5.8125 3.4875C4.2375 4.47917 3.03333 5.81667 2.2 7.5C3.03333 9.18333 4.2375 10.5208 5.8125 11.5125C7.3875 12.5042 9.11667 13 11 13Z"
                fill="#fff"
              />
            </svg>
            <span>Preview Video</span>
          </button>
          <button
            class="btn-navbar-personalization btn-next"
            type="button"
            *ngIf="invitationType == 2"
            (click)="GenerateVideo($event)"
            [ngClass]="{
              active: TemplateMetaData?.SlideData?.length == activeSlide
            }"
          >
            <svg
              width="22"
              height="15"
              viewBox="0 0 22 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 12C12.25 12 13.3125 11.5625 14.1875 10.6875C15.0625 9.8125 15.5 8.75 15.5 7.5C15.5 6.25 15.0625 5.1875 14.1875 4.3125C13.3125 3.4375 12.25 3 11 3C9.75 3 8.6875 3.4375 7.8125 4.3125C6.9375 5.1875 6.5 6.25 6.5 7.5C6.5 8.75 6.9375 9.8125 7.8125 10.6875C8.6875 11.5625 9.75 12 11 12ZM11 10.2C10.25 10.2 9.6125 9.9375 9.0875 9.4125C8.5625 8.8875 8.3 8.25 8.3 7.5C8.3 6.75 8.5625 6.1125 9.0875 5.5875C9.6125 5.0625 10.25 4.8 11 4.8C11.75 4.8 12.3875 5.0625 12.9125 5.5875C13.4375 6.1125 13.7 6.75 13.7 7.5C13.7 8.25 13.4375 8.8875 12.9125 9.4125C12.3875 9.9375 11.75 10.2 11 10.2ZM11 15C8.56667 15 6.35 14.3208 4.35 12.9625C2.35 11.6042 0.9 9.78333 0 7.5C0.9 5.21667 2.35 3.39583 4.35 2.0375C6.35 0.679167 8.56667 0 11 0C13.4333 0 15.65 0.679167 17.65 2.0375C19.65 3.39583 21.1 5.21667 22 7.5C21.1 9.78333 19.65 11.6042 17.65 12.9625C15.65 14.3208 13.4333 15 11 15ZM11 13C12.8833 13 14.6125 12.5042 16.1875 11.5125C17.7625 10.5208 18.9667 9.18333 19.8 7.5C18.9667 5.81667 17.7625 4.47917 16.1875 3.4875C14.6125 2.49583 12.8833 2 11 2C9.11667 2 7.3875 2.49583 5.8125 3.4875C4.2375 4.47917 3.03333 5.81667 2.2 7.5C3.03333 9.18333 4.2375 10.5208 5.8125 11.5125C7.3875 12.5042 9.11667 13 11 13Z"
                fill="#fff"
              />
            </svg>
            <span>Preview Card</span>
          </button>
          <button
            class="btn-navbar-personalization btn-next ml-3"
            [disabled]="isSaveDisable || isPayDisable"
            (click)="payAndDownload()"
          >
            Download
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 6.00007C13.9951 5.47397 13.7832 4.97097 13.41 4.60007L9.12 0.30007C8.93264 0.113819 8.67919 0.00927734 8.415 0.00927734C8.15082 0.00927734 7.89736 0.113819 7.71 0.30007C7.61627 0.393033 7.54188 0.503634 7.49111 0.625494C7.44034 0.747353 7.4142 0.878058 7.4142 1.01007C7.4142 1.14208 7.44034 1.27279 7.49111 1.39465C7.54188 1.51651 7.61627 1.62711 7.71 1.72007L11 5.00007H1C0.734784 5.00007 0.48043 5.10543 0.292893 5.29296C0.105357 5.4805 0 5.73485 0 6.00007C0 6.26529 0.105357 6.51964 0.292893 6.70718C0.48043 6.89471 0.734784 7.00007 1 7.00007H11L7.71 10.2901C7.5217 10.477 7.41538 10.7312 7.41444 10.9965C7.41351 11.2619 7.51802 11.5168 7.705 11.7051C7.89198 11.8934 8.1461 11.9997 8.41147 12.0006C8.67683 12.0016 8.9317 11.897 9.12 11.7101L13.41 7.41007C13.7856 7.03672 13.9978 6.52965 14 6.00007Z"
                fill="white"
              />
            </svg>
          </button>
        </form>
      </div>
    </nav>
  </div>
  <section
    class="bg-light-300 preview-container-height"
    *ngIf="isPersonalizeDataLoaded"
    [style.display]="isFromServer ? 'none' : ''"
  >
    <div class="video-editing-page">
      <div class="slider-thumbnails d-none d-md-block" #sliderThumbnails>
        <div class="card">
          <div class="card-body">
            <div class="mx-auto mt-2" style="width: fit-content">
              <button
                class="btn-navbar-personalization"
                s
                (click)="toggleSlideIn('swap')"
                style="margin-left: -54px; background-color: #ce1153"
              >
                <div class="d-flex align-item-center gap-10">
                  <svg
                    style="margin-top: 4px"
                    height="20px"
                    width="20px"
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xml:space="preserve"
                    fill="#fff"
                  >
                    <g>
                      <polygon
                        points="256,381.424 104.628,328.845 0,365.186 256,454.114 512,365.186 407.373,328.845 	"
                      />
                      <polygon
                        points="256,272.235 104.628,219.655 0,255.996 256,344.924 512,255.996 407.373,219.655 	"
                      />
                      <polygon
                        points="512,146.806 256,57.886 0,146.806 256,235.734 	"
                      />
                    </g>
                  </svg>
                  <p class="mb-0 text-white">Re-Order Clips</p>
                </div>
              </button>
            </div>
            <ul class="list-inline nav-sliders mb-0 align-items-center">
              <li class="mobile-thumbnail-width">
                <div class="example-container">
                  <div style="width: fit-content" class="mx-auto">
                    <div
                      *ngFor="
                        let item of TemplateMetaData?.SlideData;
                        let i = index
                      "
                    >
                      <button
                        *ngIf="displayType == 2"
                        class="slide-thumbnails"
                        [ngClass]="{ active: i == activeSlide }"
                        (click)="goToSlide(i)"
                      >
                        <span
                          class="exclude-thumnail cursor-pointer"
                          (click)="checkboxChange(item)"
                        >
                          <svg
                            *ngIf="item.IsIncluded"
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#5f6368"
                          >
                            <path
                              d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                            />
                          </svg>
                          <svg
                            *ngIf="!item.IsIncluded"
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#5f6368"
                          >
                            <path
                              d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                            />
                          </svg>
                        </span>

                        <div class *ngIf="item.IsIncluded">
                          <img
                            src="{{ item.SlideImageLink }}"
                            alt="247Invites"
                          />
                        </div>
                        <div class="exclude-image" *ngIf="!item.IsIncluded">
                          <img
                            src="{{ item.SlideImageLink }}"
                            alt="247Invites"
                          />
                        </div>
                      </button>

                      <button
                        *ngIf="displayType == 1"
                        class="slide-thumbnails"
                        [ngClass]="{ active: i == activeSlide }"
                        (click)="goToSlide(i)"
                      >
                        <span
                          class="exclude-thumnail cursor-pointer"
                          (click)="checkboxChange(item)"
                        >
                          <svg
                            *ngIf="item.IsIncluded"
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#5f6368"
                          >
                            <path
                              d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                            />
                          </svg>
                          <svg
                            *ngIf="!item.IsIncluded"
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#5f6368"
                          >
                            <path
                              d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                            />
                          </svg>
                        </span>

                        <div class *ngIf="item.IsIncluded">
                          <img
                            class="landscape-img"
                            src="{{ item.SlideImageLink }}"
                            alt="247Invites"
                          />
                        </div>
                        <div
                          class="exclude-image exclude-image-landscape"
                          *ngIf="!item.IsIncluded"
                        >
                          <img
                            class="landscape-img"
                            src="{{ item.SlideImageLink }}"
                            alt="247Invites"
                          />
                        </div>
                      </button>
                    </div>
                    <button
                      class="btn-navbar-personalization w-100"
                      (click)="
                        goToSlide(TemplateMetaData?.SlideData?.length + 1)
                      "
                    >
                      <div class="">Preview</div>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container-main mx-auto container-main-only">
        <div class="instruction-text d-none">
          <div class="card">
            <div class="card-body">
              <h5>Clip Include/Exclude in Video</h5>
              <p>
                The thumbnail marked with (x) signifies the option to remove the
                clip from the final video, while the thumbnail marked with (+)
                signifies the option to retain the clip in the final video.
              </p>
              <h5 class="mt-4">Clip Re-Order</h5>
              <p>
                You now have the ability to adjust the sequence of clips by
                simply swiping the thumbnails.
              </p>
            </div>
          </div>
        </div>
        <div class="editing-container old-video-editing-page">
          <owl-carousel-o
            [options]="owlOptions"
            #personalizeVideo
            (changed)="onCarouselChange($event)"
          >
            <ng-template
              carouselSlide
              *ngFor="let item of TemplateMetaData.SlideData; let i = index"
              [id]="i"
            >
              <div class="car-prev-btn">
                <i
                  class="fa fa-chevron-left"
                  aria-hidden="true"
                  (click)="personalizeVideo.prev()"
                ></i>
              </div>
              <div class="car-next-btn">
                <i
                  class="fa fa-chevron-right"
                  aria-hidden="true"
                  (click)="personalizeVideo.next()"
                ></i>
              </div>
              <div
                [ngClass]="item.IsIncluded ? '' : 'disabled-slide'"
                class="d-block d-md-none"
              ></div>
              <div
                class="card mobile-preview-container"
                [ngClass]="item.IsIncluded ? '' : 'mobile-disabled-slide'"
              >
                <div class="card-body card-dots-padding">
                  <div class="include-check d-none">
                    <div
                      class="row justify-content-center justify-content-md-end mb-2"
                    >
                      <div class="col-md-auto col-auto">
                        <div class="custom-control custom-checkbox">
                          <input
                            class="custom-control-input"
                            type="checkbox"
                            [id]="'check' + i"
                            [name]="'check' + i"
                            [checked]="item.IsIncluded"
                            (change)="checkboxChange(item)"
                          />
                          <label
                            class="custom-control-label"
                            [for]="'check' + i"
                            >Include Clip</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    [ngClass]="item.IsIncluded ? '' : 'disabled-text'"
                    *ngIf="!item.IsIncluded"
                  >
                    <span class="d-block d-md-none">
                      This clip is now removed from video and it will not
                      included in final video, use below button to add/edit
                      clip.
                    </span>
                    <span class="d-md-block d-none">
                      This clip is now removed from video and it will not
                      included in final video, if you want to add this clip in
                      video click (+) on to include again in video.
                    </span>
                    <div
                      class="d-flex d-md-none mt-3 flex-column align-items-center button cursor-pointer btn btn-light-gray"
                      (click)="toggleSlideIn('delete')"
                      style="background-color: #ce1153"
                    >
                      <div class="d-flex align-items-center" style="gap: 5px">
                        <svg
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 18C2.45 18 1.97917 17.8042 1.5875 17.4125C1.19583 17.0208 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8042 17.0208 14.4125 17.4125C14.0208 17.8042 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
                            fill="#fff"
                          />
                        </svg>
                        <p
                          class="mb-0 text-dark"
                          style="
                            font-size: 15px !important;
                            color: #fff !important;
                          "
                        >
                          Add/Delete Clip
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-none d-md-block"
                    [ngClass]="item.IsIncluded ? '' : 'disabled-slide'"
                  ></div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class>
                        <div
                          [class]="
                            previewGenerationInProgress
                              ? 'img-preview-loader'
                              : ''
                          "
                        >
                          <div
                            class="prev-loader"
                            *ngIf="previewGenerationInProgress"
                          >
                            <div class="loader1"></div>
                            <label class="mt-2">Generating Preview</label>
                          </div>
                          <img
                            src="{{ item.SlideImageLink }}"
                            class="img-fluid img-preview"
                            alt="Responsive image"
                            (click)="scrollToInput()"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-inputs-row">
                        <h5
                          class="ml-2 mt-4 d-none mb-0 d-md-none text-center mx-auto"
                        >
                          Enter Event Details
                        </h5>
                        <div class="form-row slide-text-area mt-md-0">
                          <div
                            [ngClass]="{
                              'col-6 col-sm-6': itemObj.FieldType == 'Picture',
                              'col-lg-12': itemObj.FieldType == 'Textbox'
                            }"
                            *ngFor="
                              let itemObj of item.FieldData;
                              let j = index
                            "
                          >
                            <!-- text box -->

                            <div
                              class="form-group"
                              *ngIf="itemObj.FieldType == 'Textbox'"
                              [ngClass]="{
                                error:
                                  itemObj.FieldValue.length >=
                                  itemObj?.FieldLength
                              }"
                            >
                              <input
                                type="text"
                                id="first-input"
                                class="form-control"
                                [name]="itemObj.FieldName"
                                [placeholder]="itemObj.FieldToolTip"
                                [(ngModel)]="itemObj.FieldValue"
                                [maxLength]="itemObj?.FieldLength + 10"
                                (ngModelChange)="
                                  textChange(itemObj?.CasingTypeId, itemObj)
                                "
                              />
                              <div class="remaining-text-length">
                                {{
                                  itemObj?.FieldLength +
                                    10 -
                                    itemObj?.FieldValue?.length
                                }}
                              </div>
                              <div
                                class="validation-req d-none"
                                *ngIf="!itemObj.IsOptional"
                              ></div>
                            </div>
                            <!-- picture -->
                            <div
                              class="img-upload-thumbnail position-relative"
                              *ngIf="itemObj.FieldType == 'Picture'"
                            >
                              <div
                                *ngIf="!itemObj.FileCroppedValue"
                                class="img-placeholder"
                              >
                                <img
                                  src="/assets/images/image-upload-thumbnail.svg"
                                />
                                <div>Drag and drop an image, or Browse</div>
                              </div>
                              <div
                                class="user-image"
                                *ngIf="itemObj.FileCroppedValue"
                              >
                                <div
                                  class="file-uploaded-status-row d-flex justify-content-between"
                                >
                                  <img
                                    class="thumbnail-uploaded"
                                    [src]="itemObj.FileCroppedValue"
                                    alt="Cropped Image"
                                  />
                                  <div class="success-100">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                                        fill="#28AB59"
                                      />
                                    </svg>
                                    <span class="d-none d-md-flex"
                                      >Uploaded!</span
                                    >
                                  </div>
                                </div>
                                <div class="file-uploaded-status-row">
                                  <div class="delete-100">
                                    <a
                                      class="cursor-pointer"
                                      (click)="deleteImage(itemObj)"
                                    >
                                      <svg
                                        width="16"
                                        height="18"
                                        viewBox="0 0 16 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M3 18C2.45 18 1.97917 17.8042 1.5875 17.4125C1.19583 17.0208 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8042 17.0208 14.4125 17.4125C14.0208 17.8042 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
                                          fill="#888888"
                                        />
                                      </svg>
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <input
                                type="file"
                                class="hide-input"
                                accept="image/*"
                                onclick="this.value= null"
                                (change)="
                                  fileChangeEvent($event, itemObj.FieldName)
                                "
                              />
                              <span class *ngIf="!itemObj.IsOptional"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="btn-row align-items-center justify-content-between d-none d-md-flex"
                      >
                        <button
                          class="btn-personalization btn-back btn-slide-disabled"
                          [ngClass]="
                            item.IsIncluded ? '' : 'mobile-disabled-back-btn'
                          "
                          (click)="personalizeVideo.prev()"
                        >
                          <svg
                            width="14"
                            height="12"
                            viewBox="0 0 14 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M-1.90735e-06 6.00007C0.00486469 5.47397 0.216843 4.97097 0.589998 4.60007L4.88 0.30007C5.06736 0.113819 5.32081 0.00927734 5.585 0.00927734C5.84918 0.00927734 6.10264 0.113819 6.29 0.30007C6.38373 0.393033 6.45812 0.503634 6.50889 0.625494C6.55966 0.747353 6.5858 0.878058 6.5858 1.01007C6.5858 1.14208 6.55966 1.27279 6.50889 1.39465C6.45812 1.51651 6.38373 1.62711 6.29 1.72007L3 5.00007H13C13.2652 5.00007 13.5196 5.10543 13.7071 5.29296C13.8946 5.4805 14 5.73485 14 6.00007C14 6.26529 13.8946 6.51964 13.7071 6.70718C13.5196 6.89471 13.2652 7.00007 13 7.00007H3L6.29 10.2901C6.4783 10.477 6.58462 10.7312 6.58556 10.9965C6.58649 11.2619 6.48198 11.5168 6.295 11.7051C6.10802 11.8934 5.8539 11.9997 5.58853 12.0006C5.32317 12.0016 5.0683 11.897 4.88 11.7101L0.589998 7.41007C0.214411 7.03672 0.00223064 6.52965 -1.90735e-06 6.00007Z"
                              fill="#E4286A"
                            />
                          </svg>
                          <span>Back</span>
                        </button>
                        <button
                          class="btn-personalization btn-preview"
                          type="button"
                          (click)="slidePreview(item)"
                          [disabled]="
                            previewGenerationInProgress || isSaveDisable
                          "
                        >
                          <svg
                            width="22"
                            height="15"
                            viewBox="0 0 22 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11 12C12.25 12 13.3125 11.5625 14.1875 10.6875C15.0625 9.8125 15.5 8.75 15.5 7.5C15.5 6.25 15.0625 5.1875 14.1875 4.3125C13.3125 3.4375 12.25 3 11 3C9.75 3 8.6875 3.4375 7.8125 4.3125C6.9375 5.1875 6.5 6.25 6.5 7.5C6.5 8.75 6.9375 9.8125 7.8125 10.6875C8.6875 11.5625 9.75 12 11 12ZM11 10.2C10.25 10.2 9.6125 9.9375 9.0875 9.4125C8.5625 8.8875 8.3 8.25 8.3 7.5C8.3 6.75 8.5625 6.1125 9.0875 5.5875C9.6125 5.0625 10.25 4.8 11 4.8C11.75 4.8 12.3875 5.0625 12.9125 5.5875C13.4375 6.1125 13.7 6.75 13.7 7.5C13.7 8.25 13.4375 8.8875 12.9125 9.4125C12.3875 9.9375 11.75 10.2 11 10.2ZM11 15C8.56667 15 6.35 14.3208 4.35 12.9625C2.35 11.6042 0.9 9.78333 0 7.5C0.9 5.21667 2.35 3.39583 4.35 2.0375C6.35 0.679167 8.56667 0 11 0C13.4333 0 15.65 0.679167 17.65 2.0375C19.65 3.39583 21.1 5.21667 22 7.5C21.1 9.78333 19.65 11.6042 17.65 12.9625C15.65 14.3208 13.4333 15 11 15ZM11 13C12.8833 13 14.6125 12.5042 16.1875 11.5125C17.7625 10.5208 18.9667 9.18333 19.8 7.5C18.9667 5.81667 17.7625 4.47917 16.1875 3.4875C14.6125 2.49583 12.8833 2 11 2C9.11667 2 7.3875 2.49583 5.8125 3.4875C4.2375 4.47917 3.03333 5.81667 2.2 7.5C3.03333 9.18333 4.2375 10.5208 5.8125 11.5125C7.3875 12.5042 9.11667 13 11 13Z"
                              fill="#E4286A"
                            />
                          </svg>
                          <span>Preview</span>
                        </button>
                        <button
                          class="btn-personalization btn-next btn-slide-disabled"
                          (click)="personalizeVideo.next()"
                        >
                          <span>Next</span>
                          <svg
                            width="14"
                            height="12"
                            viewBox="0 0 14 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14 6.00007C13.9951 5.47397 13.7832 4.97097 13.41 4.60007L9.12 0.30007C8.93264 0.113819 8.67919 0.00927734 8.415 0.00927734C8.15082 0.00927734 7.89736 0.113819 7.71 0.30007C7.61627 0.393033 7.54188 0.503634 7.49111 0.625494C7.44034 0.747353 7.4142 0.878058 7.4142 1.01007C7.4142 1.14208 7.44034 1.27279 7.49111 1.39465C7.54188 1.51651 7.61627 1.62711 7.71 1.72007L11 5.00007H1C0.734784 5.00007 0.48043 5.10543 0.292893 5.29296C0.105357 5.4805 0 5.73485 0 6.00007C0 6.26529 0.105357 6.51964 0.292893 6.70718C0.48043 6.89471 0.734784 7.00007 1 7.00007H11L7.71 10.2901C7.5217 10.477 7.41538 10.7312 7.41444 10.9965C7.41351 11.2619 7.51802 11.5168 7.705 11.7051C7.89198 11.8934 8.1461 11.9997 8.41147 12.0006C8.67683 12.0016 8.9317 11.897 9.12 11.7101L13.41 7.41007C13.7856 7.03672 13.9978 6.52965 14 6.00007Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template
              carouselSlide
              [id]="
                TemplateMetaData?.SlideData?.length > 0
                  ? TemplateMetaData?.SlideData?.length + 1
                  : 1
              "
            >
              <div class="car-prev-btn">
                <i
                  class="fa fa-chevron-left"
                  aria-hidden="true"
                  (click)="personalizeVideo.prev()"
                ></i>
              </div>
              <div class="car-next-btn">
                <i
                  class="fa fa-chevron-right"
                  aria-hidden="true"
                  (click)="personalizeVideo.next()"
                ></i>
              </div>
              <div class="card mobile-preview-container">
                <div class="card-body card-dots-padding">
                  <div class="row mmx-0 mt-3 align-item-center m-pad-10">
                    <div class="col-md-12 col-12 mpx-5 mb-3">
                      <div *ngIf="!isShowPreviewStatus">
                        <div *ngIf="invitationType == 1">
                          <div class="mt-2">
                            <div class="row align-items-start file-input">
                              <div class="col-md-6 m-mt-10">
                                <div class="row">
                                  <div class="col-md-12">
                                    <h5 class="font-500">Default Music</h5>
                                    <div>
                                      <select
                                        class="form-control"
                                        (change)="
                                          changeAudio($event.target.value, true)
                                        "
                                        [(ngModel)]="audioPath"
                                      >
                                        {{
                                          TemplateMetaData.TemplateAudio
                                        }}
                                        <option
                                          *ngFor="
                                            let templateAudio of TemplateMetaData.TemplateAudio
                                          "
                                          value="{{ templateAudio.AudioPath }}"
                                        >
                                          {{ templateAudio.AudioTitle }}
                                        </option>
                                      </select>
                                    </div>
                                    <div class>
                                      <audio
                                        controls
                                        *ngIf="showAudioPlayer"
                                        class="mt-3 w-100 custom-audio-player"
                                      >
                                        <source
                                          [src]="finalAudioPath"
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                    </div>
                                  </div>
                                  <div class="col-md-12 mt-3">
                                    <label
                                      for="file-input"
                                      [ngClass]="
                                        uploadMusicText === 'Audio Uploaded!!'
                                          ? 'btn-upload-audio-green d-flex justify-content-center'
                                          : 'btn-upload-audio d-flex justify-content-center'
                                      "
                                      class
                                    >
                                      <i
                                        [ngClass]="
                                          uploadMusicText === 'Audio Uploaded!!'
                                            ? 'fa fa-music greenaudio'
                                            : 'fa fa-music'
                                        "
                                      ></i>
                                      <input
                                        #audioFile
                                        type="file"
                                        class="ml-2 mobile-d-block mmt-15"
                                        (change)="
                                          handleAudioFileInput(
                                            $event,
                                            $event.target.files
                                          )
                                        "
                                        id="file-input"
                                        accept=".mp3, audio/*"
                                        style="display: none"
                                      />
                                      <div
                                        class="font-500"
                                        [ngClass]="
                                          uploadMusicText === 'Audio Uploaded!!'
                                            ? 'greenaudio'
                                            : ''
                                        "
                                      >
                                        {{ uploadMusicText }}
                                      </div>
                                    </label>
                                  </div>
                                  <div class="col-md-12 d-flex d-md-none mt-3">
                                    <button
                                      class="btn-personalization w-100 btn-preview"
                                      style="
                                        padding-bottom: 7px;
                                        padding-top: 7px;
                                      "
                                      [disabled]="isSaveDisable"
                                      (click)="SaveTemplateData()"
                                    >
                                      Save your work
                                    </button>
                                  </div>
                                  <div class="col-md-12 d-flex d-md-none mt-3">
                                    <button
                                      class="btn-personalization btn-next w-100"
                                      style="
                                        display: flex;
                                        gap: 5px;
                                        padding-bottom: 7px;
                                        padding-top: 7px;
                                      "
                                      (click)="GenerateVideo($event)"
                                      [ngClass]="{
                                        active:
                                          TemplateMetaData?.SlideData?.length ==
                                          activeSlide
                                      }"
                                    >
                                      <span class="material-icons">
                                        visibility
                                      </span>
                                      <span> Preview Video </span>
                                    </button>
                                  </div>
                                  <div class="col-md-12">
                                    <button
                                      type="button"
                                      class="btn btn-outline-secondary mt-3 btn-sm"
                                      fileSaver
                                      [method]="'GET'"
                                      *ngIf="IsShowDownloadAudio"
                                      [fileName]="'savedAudio'"
                                      [url]="audioFilePath"
                                    >
                                      {{ audioFileName }}
                                    </button>
                                    <div
                                      class="btn-row px-0 mt-3 d-none d-md-flex align-items-center justify-content-between"
                                    >
                                      <button
                                        class="btn-personalization btn-preview"
                                        [disabled]="isSaveDisable"
                                        (click)="SaveTemplateData()"
                                      >
                                        Save
                                      </button>
                                      <button
                                        class="btn-personalization btn-preview"
                                        style="display: flex; gap: 5px"
                                        (click)="GenerateVideo($event)"
                                        [ngClass]="{
                                          active:
                                            TemplateMetaData?.SlideData
                                              ?.length == activeSlide
                                        }"
                                      >
                                        <span>
                                          Preview {{ videoOrCardTextCap }}
                                        </span>
                                      </button>
                                      <button
                                        class="btn-personalization btn-next"
                                        [disabled]="
                                          isSaveDisable || isPayDisable
                                        "
                                        (click)="payAndDownload()"
                                      >
                                        Download
                                        <svg
                                          width="14"
                                          height="12"
                                          viewBox="0 0 14 12"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M14 6.00007C13.9951 5.47397 13.7832 4.97097 13.41 4.60007L9.12 0.30007C8.93264 0.113819 8.67919 0.00927734 8.415 0.00927734C8.15082 0.00927734 7.89736 0.113819 7.71 0.30007C7.61627 0.393033 7.54188 0.503634 7.49111 0.625494C7.44034 0.747353 7.4142 0.878058 7.4142 1.01007C7.4142 1.14208 7.44034 1.27279 7.49111 1.39465C7.54188 1.51651 7.61627 1.62711 7.71 1.72007L11 5.00007H1C0.734784 5.00007 0.48043 5.10543 0.292893 5.29296C0.105357 5.4805 0 5.73485 0 6.00007C0 6.26529 0.105357 6.51964 0.292893 6.70718C0.48043 6.89471 0.734784 7.00007 1 7.00007H11L7.71 10.2901C7.5217 10.477 7.41538 10.7312 7.41444 10.9965C7.41351 11.2619 7.51802 11.5168 7.705 11.7051C7.89198 11.8934 8.1461 11.9997 8.41147 12.0006C8.67683 12.0016 8.9317 11.897 9.12 11.7101L13.41 7.41007C13.7856 7.03672 13.9978 6.52965 14 6.00007Z"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 d-none d-md-flex">
                                <div class="row">
                                  <div class="col-md-12 final-step-notes">
                                    <ul>
                                      <li>
                                        Preview the video at least once, before
                                        you click on Pay & Download HD Quality
                                        Video.
                                      </li>
                                      <li>
                                        The 247invites.com Watermark won't be in
                                        the Final HD Quality Video.
                                      </li>
                                      <li>
                                        The preview video will be in low quality
                                        for you to review quickly.
                                      </li>
                                      <li>
                                        The Final Video will be in
                                        <span class="font-500"
                                          >HD quality.</span
                                        >
                                      </li>
                                      <li>
                                        The video will be available for download
                                        only for a period of
                                        <span class="font-500">six days</span>
                                        from the date of purchase.
                                      </li>
                                      <li>
                                        Payment can be made using your
                                        <span class="font-500"
                                          >Credit/Debit Card</span
                                        >,
                                        <span class="font-500">PayPal</span> Or
                                        <span class="font-500"
                                          >Wallets and UPI</span
                                        >.
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="invitationType == 2">
                          <div
                            class="btn-row my-3 btn-card-row align-items-center justify-content-start"
                          >
                            <button
                              class="btn-personalization btn-preview mr-2"
                              [disabled]="isSaveDisable"
                              (click)="SaveTemplateData()"
                            >
                              Save
                            </button>
                            <button
                              class="btn-personalization btn-preview mr-2"
                              style="display: flex; gap: 5px"
                              (click)="GenerateVideo($event)"
                              [ngClass]="{
                                active:
                                  TemplateMetaData?.SlideData?.length ==
                                  activeSlide
                              }"
                            >
                              <span> Preview Card </span>
                            </button>
                            <button
                              class="btn-personalization btn-next"
                              [disabled]="isSaveDisable || isPayDisable"
                              (click)="payAndDownload()"
                            >
                              Download
                              <svg
                                width="14"
                                height="12"
                                viewBox="0 0 14 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14 6.00007C13.9951 5.47397 13.7832 4.97097 13.41 4.60007L9.12 0.30007C8.93264 0.113819 8.67919 0.00927734 8.415 0.00927734C8.15082 0.00927734 7.89736 0.113819 7.71 0.30007C7.61627 0.393033 7.54188 0.503634 7.49111 0.625494C7.44034 0.747353 7.4142 0.878058 7.4142 1.01007C7.4142 1.14208 7.44034 1.27279 7.49111 1.39465C7.54188 1.51651 7.61627 1.62711 7.71 1.72007L11 5.00007H1C0.734784 5.00007 0.48043 5.10543 0.292893 5.29296C0.105357 5.4805 0 5.73485 0 6.00007C0 6.26529 0.105357 6.51964 0.292893 6.70718C0.48043 6.89471 0.734784 7.00007 1 7.00007H11L7.71 10.2901C7.5217 10.477 7.41538 10.7312 7.41444 10.9965C7.41351 11.2619 7.51802 11.5168 7.705 11.7051C7.89198 11.8934 8.1461 11.9997 8.41147 12.0006C8.67683 12.0016 8.9317 11.897 9.12 11.7101L13.41 7.41007C13.7856 7.03672 13.9978 6.52965 14 6.00007Z"
                                  fill="white"
                                />
                              </svg>
                            </button>
                          </div>
                          <div class="row pb-5 pb-md-0">
                            <div class="col-md-12 final-step-notes">
                              <ul class="pl-0 ml-0">
                                <li>
                                  Preview the card at least once, before you
                                  click on Pay & Download HD Quality Card.
                                </li>
                                <li>
                                  The 247invites.com Watermark won't be in the
                                  Final HD Quality Card.
                                </li>
                                <li>
                                  The preview video will be in low quality for
                                  you to review quickly.
                                </li>
                                <li>The Final Card will be in HD quality.</li>
                                <li>
                                  Once you click on "Pay & Download HD Quality
                                  Card" you are not allowed to edit the card
                                  again.
                                </li>
                                <li>
                                  Payment can be made using your credit/debit
                                  card, Paypal Or you can paytm the money on +91
                                  8669278777.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" *ngIf="isShowPreviewStatus">
                        <div class="col-md-6 col-12 mt-3 mt-md-1 mpx-5">
                          <div class="video-preview">
                            <div
                              class="row justify-content-center justify-content-center align-items-center mt-3"
                            >
                              <div class="col-md-auto col-auto">
                                <div [class]="ProgressBarClass">
                                  <span>{{ ProgressBarPercentage }}%</span>
                                  <div class="slice">
                                    <div class="bar"></div>
                                    <div class="fill"></div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-12 col-12 mmt-30">
                                <div
                                  class="process-label"
                                  style="clear: both"
                                  *ngIf="jobProgressData?.TaskType"
                                >
                                  <h3
                                    *ngIf="ProgressBarPercentage != '100'"
                                    [class]="ProgressTaskClass"
                                  >
                                    {{ jobProgressData?.TaskType }}
                                  </h3>
                                  <h3
                                    *ngIf="ProgressBarPercentage == '100'"
                                    class="mb-0 text-success"
                                  >
                                    {{ jobProgressData?.TaskType }}
                                  </h3>
                                </div>
                              </div>
                            </div>
                            <div
                              class="btn-row px-0 mt-3 d-none d-md-flex align-items-center justify-content-between"
                            >
                              <button
                                class="btn-personalization btn-preview"
                                [disabled]="isSaveDisable"
                                (click)="SaveTemplateData()"
                              >
                                Save
                              </button>
                              <button
                                class="btn-personalization btn-preview"
                                style="display: flex; gap: 5px"
                                (click)="GenerateVideo($event)"
                                [ngClass]="{
                                  active:
                                    TemplateMetaData?.SlideData?.length ==
                                    activeSlide
                                }"
                              >
                                <span> Preview {{ videoOrCardTextCap }} </span>
                              </button>
                              <button
                                class="btn-personalization btn-next"
                                [disabled]="isSaveDisable || isPayDisable"
                                (click)="payAndDownload()"
                              >
                                Download
                                <svg
                                  width="14"
                                  height="12"
                                  viewBox="0 0 14 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14 6.00007C13.9951 5.47397 13.7832 4.97097 13.41 4.60007L9.12 0.30007C8.93264 0.113819 8.67919 0.00927734 8.415 0.00927734C8.15082 0.00927734 7.89736 0.113819 7.71 0.30007C7.61627 0.393033 7.54188 0.503634 7.49111 0.625494C7.44034 0.747353 7.4142 0.878058 7.4142 1.01007C7.4142 1.14208 7.44034 1.27279 7.49111 1.39465C7.54188 1.51651 7.61627 1.62711 7.71 1.72007L11 5.00007H1C0.734784 5.00007 0.48043 5.10543 0.292893 5.29296C0.105357 5.4805 0 5.73485 0 6.00007C0 6.26529 0.105357 6.51964 0.292893 6.70718C0.48043 6.89471 0.734784 7.00007 1 7.00007H11L7.71 10.2901C7.5217 10.477 7.41538 10.7312 7.41444 10.9965C7.41351 11.2619 7.51802 11.5168 7.705 11.7051C7.89198 11.8934 8.1461 11.9997 8.41147 12.0006C8.67683 12.0016 8.9317 11.897 9.12 11.7101L13.41 7.41007C13.7856 7.03672 13.9978 6.52965 14 6.00007Z"
                                    fill="white"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <h5 class="what-next">What’s next?</h5>
                          <div class="final-step-notes">
                            <ul>
                              <li>
                                Wait for 2-3 minutes, System will create the
                                {{ videoOrCardTextSmall }}.
                              </li>
                              <li>Preview the {{ videoOrCardTextSmall }}</li>
                              <li>Pay only when you like the Preview.</li>
                              <li>
                                Please do not click anywhere else
                                {{ videoOrCardTextSmall }}
                                generation will stop.
                              </li>
                              <li>
                                {{ videoOrCardTextCap }} will also be available
                                under
                                <span class="text-success">"My Videos"</span>.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </owl-carousel-o>
         
        </div>
      </div>
    </div>
    <div class="p-footer">
      <div>
        <div
          *ngIf="activeSlide !== TemplateMetaData?.SlideData?.length"
          class="btn-row btn-row-fixed d-flex align-items-center justify-content-between d-md-none"
        >
          <button
            class="btn-personalization btn-back"
            (click)="personalizeVideo.prev()"
          >
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M-1.90735e-06 6.00007C0.00486469 5.47397 0.216843 4.97097 0.589998 4.60007L4.88 0.30007C5.06736 0.113819 5.32081 0.00927734 5.585 0.00927734C5.84918 0.00927734 6.10264 0.113819 6.29 0.30007C6.38373 0.393033 6.45812 0.503634 6.50889 0.625494C6.55966 0.747353 6.5858 0.878058 6.5858 1.01007C6.5858 1.14208 6.55966 1.27279 6.50889 1.39465C6.45812 1.51651 6.38373 1.62711 6.29 1.72007L3 5.00007H13C13.2652 5.00007 13.5196 5.10543 13.7071 5.29296C13.8946 5.4805 14 5.73485 14 6.00007C14 6.26529 13.8946 6.51964 13.7071 6.70718C13.5196 6.89471 13.2652 7.00007 13 7.00007H3L6.29 10.2901C6.4783 10.477 6.58462 10.7312 6.58556 10.9965C6.58649 11.2619 6.48198 11.5168 6.295 11.7051C6.10802 11.8934 5.8539 11.9997 5.58853 12.0006C5.32317 12.0016 5.0683 11.897 4.88 11.7101L0.589998 7.41007C0.214411 7.03672 0.00223064 6.52965 -1.90735e-06 6.00007Z"
                fill="#E4286A"
              />
            </svg>
            <span>Back</span>
          </button>
          <button
            class="btn-personalization btn-next"
            style="margin-left: -15px"
            type="button"
            (click)="slidePreview()"
            [disabled]="previewGenerationInProgress || isSaveDisable"
          >
            <span>Preview</span>
          </button>
          <button
            class="btn-personalization btn-preview"
            (click)="personalizeVideo.next()"
          >
            <span>Next</span>
            <svg
              fill="#E4286A"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
            >
              <path
                d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div
        *ngIf="activeSlide === TemplateMetaData?.SlideData?.length"
        class="btn-row btn-row-fixed d-flex align-items-center justify-content-between d-md-none"
      >
        <button
          class="btn-personalization btn-back px-2"
          (click)="personalizeVideo.prev()"
        >
          <svg
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M-1.90735e-06 6.00007C0.00486469 5.47397 0.216843 4.97097 0.589998 4.60007L4.88 0.30007C5.06736 0.113819 5.32081 0.00927734 5.585 0.00927734C5.84918 0.00927734 6.10264 0.113819 6.29 0.30007C6.38373 0.393033 6.45812 0.503634 6.50889 0.625494C6.55966 0.747353 6.5858 0.878058 6.5858 1.01007C6.5858 1.14208 6.55966 1.27279 6.50889 1.39465C6.45812 1.51651 6.38373 1.62711 6.29 1.72007L3 5.00007H13C13.2652 5.00007 13.5196 5.10543 13.7071 5.29296C13.8946 5.4805 14 5.73485 14 6.00007C14 6.26529 13.8946 6.51964 13.7071 6.70718C13.5196 6.89471 13.2652 7.00007 13 7.00007H3L6.29 10.2901C6.4783 10.477 6.58462 10.7312 6.58556 10.9965C6.58649 11.2619 6.48198 11.5168 6.295 11.7051C6.10802 11.8934 5.8539 11.9997 5.58853 12.0006C5.32317 12.0016 5.0683 11.897 4.88 11.7101L0.589998 7.41007C0.214411 7.03672 0.00223064 6.52965 -1.90735e-06 6.00007Z"
              fill="#E4286A"
            />
          </svg>
          <span>Back</span>
        </button>
        <button
          *ngIf="videoPath || generatedVideoPath.length > 0"
          class="btn-personalization btn-next"
          [disabled]="isSaveDisable || isPayDisable"
          (click)="payAndDownload()"
        >
          Download
        </button>
      </div>
    </div>
    <ng-template #imageCropperModal let-modal *appShellNoRender>
      <div class="modal-header">
        <h2>Add Image</h2>
        <button
          type="button"
          class="btn btn-link"
          (click)="
            modal.dismiss(
              'Cross
        click'
            )
          "
        >
          <i class="fa fa-times"></i>
        </button>
        <div class="note-text">
          Note:&nbsp; Kindly adjust/resize the image and preview the clip.
        </div>
      </div>
      <div class="modal-body">
        <image-cropper
          class="cropper"
          [maintainAspectRatio]="isMaintainAspectRatio"
          [aspectRatio]="aspectRatio"
          format="png"
          [imageFile]="editImageFile"
          (imageCropped)="imageCropped($event)"
          imageQuality="100"
        >
        </image-cropper>
        <!-- [roundCropper]="true"  -->
      </div>
      <div class="modal-footer" *ngIf="!imageUploading">
        <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button> -->
        <button
          type="button"
          class="btn btn-link"
          (click)="
            modal.close(
              'Save
        click'
            )
          "
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-light-orange"
          (click)="saveImageCropped()"
        >
          Save
        </button>
      </div>
      <div class="modal-footer" *ngIf="imageUploading">
        <button class="btn btn-light-orange">Uploading....</button>
      </div>
    </ng-template>
  </section>
</div>
<div
  *ngIf="isPersonalizeDataLoaded"
  [style.display]="isFromServer ? 'none' : ''"
>
  <div class="slide-in-container" [ngClass]="{ open: isOpen }">
    <div *ngIf="selectedContent === 'delete'">
      <div class="position-relative w-100">
        <div class="row justify-content-between align-items-center">
          <div class="col">
            <div class="delete-slide-note">Add/Delete Clips</div>
          </div>
          <div class="col-auto">
            <div class="close-slide-in-button">
              <div class="cursor-pointer" (click)="toggleSlideIn()">
                <i class="fa fa-check"></i>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div class="close-slide-in-button">
              <div class="cursor-pointer" (click)="toggleSlideIn()">
                <i class="fa fa-times"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="delete-slide">
        <div
          class="w-fit-content"
          *ngFor="let item of TemplateMetaData?.SlideData; let i = index"
        >
          <button
            class="slide-thumbnails"
            [ngClass]="{ active: i == activeSlide }"
            (click)="goToSlide(i)"
          >
            <span
              class="exclude-thumnail cursor-pointer"
              (click)="checkboxChange(item)"
            >
              <svg
                *ngIf="item.IsIncluded"
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#5f6368"
              >
                <path
                  d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                />
              </svg>
              <svg
                *ngIf="!item.IsIncluded"
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#5f6368"
              >
                <path
                  d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                />
              </svg>
            </span>
            <div class *ngIf="item.IsIncluded">
              <img class="delete-slide-image" src="{{ item.SlideImageLink }}" />
            </div>
            <div class="exclude-image" *ngIf="!item.IsIncluded">
              <img class="delete-slide-image" src="{{ item.SlideImageLink }}" />
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="swap-slide" *ngIf="selectedContent === 'swap'">
      <div class="position-relative w-100">
        <div class="row justify-content-between align-items-center">
          <div class="col">
            <div class="note text-left">Re-order Clips</div>
          </div>
          <div class="col-auto">
            <div class="close-slide-in-button">
              <div class="cursor-pointer" (click)="toggleSlideIn()">
                <i class="fa fa-check"></i>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div class="close-slide-in-button">
              <div class="cursor-pointer" (click)="toggleSlideIn()">
                <i class="fa fa-times"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dragdrop-container">
        <div class="arrow-user-guide">
          <img src="/assets/images/drag-n-drop.png" />
        </div>
        <div
          cdkDropList
          cdkDropListOrientation="verticle"
          [cdkDropListData]="TemplateMetaData?.SlideData"
          class="example-list swap-slide-btn"
          (cdkDropListDropped)="drop($event)"
        >
          <div
            *ngFor="let item of TemplateMetaData?.SlideData; let i = index"
            cdkDrag
          >
            <button
              *ngIf="displayType == 1"
              class="slide-thumbnails slide-thumbnails-landscape"
              [ngClass]="{ active: i == activeSlide }"
              (click)="goToSlide(i)"
            >
              <div class="exclude-image">
                <img src="{{ item.SlideImageLink }}" />
              </div>
            </button>
            <button
              *ngIf="displayType == 2"
              class="slide-thumbnails"
              [ngClass]="{ active: i == activeSlide }"
              (click)="goToSlide(i)"
            >
              <div class="exclude-image">
                <img src="{{ item.SlideImageLink }}" />
              </div>
            </button>
            <div *cdkDragPreview>
              <div class="drag-item-preview">
                <button
                  *ngIf="displayType == 1"
                  class="slide-thumbnails"
                  [ngClass]="{ active: i == activeSlide }"
                  (click)="goToSlide(i)"
                >
                  <div class="exclude-image">
                    <img
                      style="max-width: 180px; border-radius: 10px"
                      src="{{ item.SlideImageLink }}"
                    />
                  </div>
                </button>
                <button
                  *ngIf="displayType == 2"
                  class="slide-thumbnails"
                  [ngClass]="{ active: i == activeSlide }"
                  (click)="goToSlide(i)"
                >
                  <div class="exclude-image">
                    <img
                      style="max-width: 180px; border-radius: 10px"
                      src="{{ item.SlideImageLink }}"
                    />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div *ngIf="isPersonalizeDataLoaded" [style.display]="isFromServer ? 'none' : ''">
  <div class="container-fluid personalize-page main_content">
    <div class="section-title section-title-secondary d-flex
      justify-content-between align-items-center d-lg-none d-md-none">
      <h2 class="d-lg-none">Edit {{videoOrCardTextCap}} </h2>
      <ul class="list-inline d-flex align-items-center mb-0 d-lg-none">
        <li>
          <button class="btn btn-link p-0">
            <i class="fa fa-chevron-left" aria-hidden="true" (click)="personalizeVideo.prev()"></i>
          </button>
        </li>
        <li>
          <button class="btn btn-link ml-4 p-0">
            <i class="fa fa-chevron-right" aria-hidden="true" (click)="personalizeVideo.next()"></i>
          </button>
        </li>
      </ul>
    </div>
    <div class="header-row d-none d-md-block">
      <div class="page-title-fixed">
        <h2 class="mb-0 pb-0">
          <span>Edit {{videoOrCardTextCap}}</span>
        </h2>
      </div>
      <div class="row align-items-center justify-content-center mb-3">
        <div class="col-md-auto">

        </div>
      </div>
    </div>
  </div>
</div> -->
